import { CertificateSettingsInput, ResourceTypeEnum } from '@/types/schema';

export interface CertificateSettingsProps {
  certificateSettings: CertificateSettingsInput;
  contentType?: ResourceTypeEnum | 'EVENT';
  error?: boolean;
  showConditionSettings?: boolean;
  onChange: (certificateSettings: CertificateSettingsInput) => void;
  disabled?: boolean;
}

export enum CertificateSettingsOptions {
  AllowDownload = 'allowDownload',
  AllowSocialSharing = 'allowSocialSharing',
  AllowLinkedinProfile = 'allowLinkedinProfile',
  MinPercentage = 'minPercentage',
}
